import { entitlementExists } from '../../main/entitlementService';

export const OBT_ROLE_COC = 'coc@obt';
export const OBT_ROLE_ACCOUNTANT = 'accountant@obt';
export const OBT_ROLE_DEFAULT = 'default@obt';
export const OBT_ROLE_SUPPORT = 'support@obt';
export const OBT_ROLE_LEGAL = 'legal@obt';

export const OBT_ACCESS_ENTITLEMENTS = [
    OBT_ROLE_COC,
    OBT_ROLE_ACCOUNTANT,
    OBT_ROLE_DEFAULT,
    OBT_ROLE_SUPPORT,
    OBT_ROLE_LEGAL,
];

const OBT_PARTNER_MAINTAIN_ENTITLEMENTS = [
    OBT_ROLE_COC
];

const OBT_CONTACT_MAINTAIN_ENTITLEMENTS = [
    OBT_ROLE_COC,
    OBT_ROLE_ACCOUNTANT,
    OBT_ROLE_SUPPORT
];

const OBT_CHANNEL_MAINTAIN_ENTITLEMENTS = [
    OBT_ROLE_COC,
    OBT_ROLE_SUPPORT
];

const OBT_LEGAL_MAINTAIN_ENTITLEMENTS = [
    OBT_ROLE_COC,
    OBT_ROLE_LEGAL
];

const OBT_BULK_UPDATE_ENTITLEMENTS = [
    OBT_ROLE_COC
];

export type ObtAccessRights = {
    canAccessObt: boolean;
    canMaintainPartner: boolean;
    canMaintainContacts: boolean;
    canMaintainChannels: boolean;
    canMaintainLegal: boolean;
    canMaintainBulkUpdate: boolean;
};

export const getObtAccessRights = (distinctEntitlements: string[]): ObtAccessRights => ({
    canAccessObt: entitlementExists(OBT_ACCESS_ENTITLEMENTS, distinctEntitlements),
    canMaintainPartner: entitlementExists(OBT_PARTNER_MAINTAIN_ENTITLEMENTS, distinctEntitlements),
    canMaintainContacts: entitlementExists(OBT_CONTACT_MAINTAIN_ENTITLEMENTS, distinctEntitlements),
    canMaintainChannels: entitlementExists(OBT_CHANNEL_MAINTAIN_ENTITLEMENTS, distinctEntitlements),
    canMaintainLegal: entitlementExists(OBT_LEGAL_MAINTAIN_ENTITLEMENTS, distinctEntitlements),
    canMaintainBulkUpdate: entitlementExists(OBT_BULK_UPDATE_ENTITLEMENTS, distinctEntitlements),
});
